/**
 * Fonction utilitaire pour formater les dates selon la période d'agrégation
 * @param date - La date à formater (string ou Date)
 * @param aggregateWindow - La fenêtre d'agrégation ('1h', '1d', '1w', '1mo', '1y')
 * @returns La date formatée selon la période
 */
export const formatDateByPeriod = (date: string | Date, aggregateWindow: string): string => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  
  switch (aggregateWindow) {
    case '15m':
      return dateObj.toLocaleString('fr-FR', {
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    case '1h':
      return dateObj.toLocaleString('fr-FR', {
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    case '1d':
      return dateObj.toLocaleDateString('fr-FR', {
        month: 'short',
        day: 'numeric'
      });
    case '1w':
      return dateObj.toLocaleDateString('fr-FR', {
        month: 'short',
        day: 'numeric'
      });
    case '1mo':
      return dateObj.toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: 'short'
      });
    case '1y':
      return dateObj.toLocaleDateString('fr-FR', {
        year: 'numeric'
      });
    default:
      return dateObj.toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
  }
};

/**
 * Fonction pour obtenir le label de période en français
 * @param aggregateWindow - La fenêtre d'agrégation
 * @returns Le label de période en français
 */
export const getPeriodLabel = (aggregateWindow: string): string => {
  switch (aggregateWindow) {
    case '15m':
      return 'par 15 minutes';
    case '1h':
      return 'horaire';
    case '1d':
      return 'journalière';
    case '1w':
      return 'hebdomadaire';
    case '1mo':
      return 'mensuelle';
    case '1y':
      return 'annuelle';
    default:
      return 'personnalisé';
  }
};
